import { Box } from '@factorialco/deprecated-design-system'

const FallbackPlaceholder = ({ title }: { title: string }) => (
  <Box
    style={{
      width: '260px',
      height: '160px',
      borderRadius: '12px',
      overflow: 'hidden',
      flexShrink: '0',
      backgroundColor: 'var(--color-radicalRed600)',
    }}
    alignItems="center"
    justifyContent="center"
    padding="s12"
  >
    <Box
      style={{
        color: 'white',
        textAlign: 'center',
        lineHeight: '1.3',
        fontSize: '13px',
        fontWeight: '500',
      }}
    >
      {title}
    </Box>
  </Box>
)

export default FallbackPlaceholder
